const PRICE_DISCOVERY_TAGS_STATE_KEY = 'priceDiscoveryTags';
const PRICE_DISCOVERY_TAGS_STORAGE_KEY = 'pmPriceDiscoveryTags';

function hasUntrustedTagsQuery(): boolean {
    try {
        return new URLSearchParams(window.location.search).has('tags');
    } catch {
        return false;
    }
}

function isPageReload(): boolean {
    try {
        const entry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
        return entry?.type === 'reload';
    } catch {
        return false;
    }
}

export function rememberPriceDiscoveryTags(tags: string): void {
    try {
        if (tags) {
            sessionStorage.setItem(PRICE_DISCOVERY_TAGS_STORAGE_KEY, tags);
        } else {
            sessionStorage.removeItem(PRICE_DISCOVERY_TAGS_STORAGE_KEY);
        }
    } catch {
        // Private mode or storage disabled — refresh will not restore tags.
    }
}

/**
 * Search terms for price discovery.
 *
 * The `tags` query param used to carry these terms encrypted with the public
 * storage key, so anyone could forge a link that searched and saved arbitrary
 * text. Terms are accepted only from in-app router state, the matching history
 * entry, or this tab's sessionStorage on a real reload. A URL that includes
 * `tags` is ignored.
 */
export function readTrustedPriceDiscoveryTags(router: { getCurrentNavigation(): { extras?: { state?: Record<string, unknown> } } | null }): string {
    if (hasUntrustedTagsQuery()) {
        rememberPriceDiscoveryTags('');
        return '';
    }

    const fromNavigation = router.getCurrentNavigation()?.extras?.state?.[PRICE_DISCOVERY_TAGS_STATE_KEY];
    if (typeof fromNavigation === 'string') {
        rememberPriceDiscoveryTags(fromNavigation);
        return fromNavigation;
    }

    const fromHistory = (history.state as Record<string, unknown> | null)?.[PRICE_DISCOVERY_TAGS_STATE_KEY];
    if (typeof fromHistory === 'string') {
        rememberPriceDiscoveryTags(fromHistory);
        return fromHistory;
    }

    if (isPageReload()) {
        try {
            return sessionStorage.getItem(PRICE_DISCOVERY_TAGS_STORAGE_KEY) || '';
        } catch {
            return '';
        }
    }

    rememberPriceDiscoveryTags('');
    return '';
}

export function priceDiscoveryTagsNavigationState(tags: string): { priceDiscoveryTags: string } {
    return { [PRICE_DISCOVERY_TAGS_STATE_KEY]: tags };
}
